import React, { useEffect, useState } from 'react'
import { MdErrorOutline } from 'react-icons/md'
import { useToast } from '../../controls/Toast/ToastService'
import LoadingContainer from '../../controls/LoadingContainer'
import Empty from '../../controls/Empty'
import { IoMdOpen } from 'react-icons/io'
import { Link, useParams } from 'react-router-dom'
import Paging from '../../controls/Paging'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import Input from '../../controls/Input'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { PAGE_SIZE } from '../../../configurations/initUrls'
import useDebounce from '../../../configurations/commonlib/useDebounce'
import moment from 'moment'
import StatusContainer from '../../controls/StatusContainer';
import { ESourceBg, GetESourceName } from '../../../configurations/enums/ESource'
import { ETypeBg, GetETypeName } from '../../../configurations/enums/EType'
import { EOPDConfirmedStatusBg, GetEOPDConfirmedStatusName } from '../../../configurations/enums/EOPDConfirmedStatus'
import Datepicker from 'react-tailwindcss-datepicker'
import { GetEGenderName } from '../../../configurations/enums/EGender'
import useGlobalLoader from '../../../configurations/useGlobalLoader'
const NEXT_MONTH = new Date();
NEXT_MONTH.setMonth(NEXT_MONTH.getMonth() - 1);
//const TODAY = new Date();


export default function GetAllConfirmed() {
const{start,end} = useGlobalLoader()
  const [dateVal, setDateVal] = useState({
    startDate: NEXT_MONTH,
    endDate: new Date()
  });
  useEffect(() => {
    setSearch(pre => (
      {
        ...pre,
        FromDate: moment(new Date(dateVal.startDate)).format("MM/DD/YYYY"),
        ToDate: moment(new Date(dateVal.endDate)).format("MM/DD/YYYY")
      }))
  }, [dateVal])


  var date = new Date()
  const { userid } = useParams()
  const initValues = {
    UserId: userid,
    PageNo: 1,
    PageSize: PAGE_SIZE,
    SearchTerm: "",
    FromDate: moment(NEXT_MONTH).format("MM/DD/YYYY"),
    ToDate: moment(new Date()).format("MM/DD/YYYY"),
  }
  const toast = useToast()
  const [loding, setLoding] = useState(false)
  const [lodingCrud, setLodingCrud] = useState(false)
  const [userData, setUserData] = useState([]);
  const [search, setSearch] = useState(initValues);
  const [LastPage, setLastPage] = useState(1);
  const [pagingData, setPagingData] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchDebounce, setSearchDebounce] = useDebounce("", 700);


  useEffect(() => {
    setSearchDebounce(searchTerm)
  }, [searchTerm])

  useEffect(() => {
    onSearch()
  }, [searchDebounce])

  useEffect(() => {
    onSearch()
  }, [search.FromDate, search.ToDate])

  const OnPageChange = (e) => {
    setSearch({ ...search, PageNo: e })
    onSearchNew({
      UserId: search.UserId,
      PageNo: e,
      PageSize: search.PageSize,
      SearchTerm: search.SearchTerm,
      FromDate: moment(new Date(dateVal.startDate)).format("MM/DD/YYYY"),
      ToDate: moment(new Date(dateVal.endDate)).format("MM/DD/YYYY"),
    })
  }

  const onSearchChange = (e) => {
    setSearchTerm(e.target.value)
  }

  const onSearch = () => {
    onSearchNew({
      UserId: search.UserId,
      PageNo: 1,
      PageSize: search.PageSize,
      SearchTerm: searchTerm,
      FromDate: search.FromDate,
      ToDate: search.ToDate,
    })
  }

  const onSearchNew = (search) => {
    GetAllConfirmed(search)
  }
  const GetAllConfirmed = (params) => {
    setLoding(true)
    start()
    opdRegisteredCrud.GetAllConfirmed(params).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setUserData(mdata.data)
        setPagingData(mdata.paging)
        setLastPage(mdata.paging.pageCount)
      } else {
        setPagingData()
        setLastPage(1)
        setUserData([])
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setPagingData()
      setLastPage(1)
      setUserData([])
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  return (
    <div className='flex flex-col '>
      <div className='flex flex-col sm:flex-row sm:space-x-3'>
        <div className='w-full py-3'>
          <Datepicker
            popoverDirection='down'
            displayFormat="DD/MM/YYYY"
            readOnly={true}
            separator="to"
            primaryColor={"sky"}
            value={dateVal}
            onChange={newValue => setDateVal(newValue)}
            showShortcuts={true}
            inputClassName="outline-blue-400 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 w-full p-2.5"
          />
        </div>
        <div className='w-full py-3'>
          <Input Icon={<FontAwesomeIcon color='gray' icon={faSearch} />}
            onChange={onSearchChange}
            placeholder="Search..."></Input>
        </div>
      </div>
      <Paging LastPage={LastPage} CurrentPage={search.PageNo} OnPageChange={OnPageChange} pagingData={pagingData} >
        <div class="overflow-x-auto">
          {
            !loding ?
              userData.length > 0 ?
                <table class="border w-full text-sm text-left rtl:text-right text-gray-500 ">
                  <thead class="text-xs text-gray-700 uppercase bg-gray-200 ">
                    <tr>
                      <th scope="col" class="px-2 py-3">
                        <div class="flex items-center">
                          <input id="checkbox-all" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500  focus:ring-2 " />
                          <label for="checkbox-all" class="sr-only">checkbox</label>
                        </div>
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Center
                      </th>
                      <th scope="col" class="px-2 py-3">
                        #
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Patient Name
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Gender
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Address
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Phone
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Age/Weight
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Note
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Comment
                      </th>
                       <th scope="col" class="px-2 py-3">
                        Date
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Status
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Source
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Type
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {userData.map((item, index) =>
                      <tr class="bg-white border-b hover:bg-gray-100">
                        <td class="w-4 px-2 py-2">
                          <div class="flex items-center">
                            <input id="checkbox-table-search-1" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2" />
                            <label for="checkbox-table-search-1" class="sr-only">checkbox</label>
                          </div>
                        </td>
                        <td class="px-2 py-3 text-nowrap">
                          {item.opdCenter.id}) {item.opdCenter.centerName}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {item.id}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {item.patientName}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {GetEGenderName(item.gender)}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {item.patientAddress}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {item.mobile}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {item.age}/{item.weight}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                         {item.note ? item.note : "N/A"}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {item.acceptedWithComment ? item.acceptedWithComment : "N/A"}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {moment(item.onDate).format("DD/MMM/YYYY")}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          <StatusContainer bg={EOPDConfirmedStatusBg(item.status)} text={GetEOPDConfirmedStatusName(item.status)} />
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          <StatusContainer bg={ESourceBg(item.source)} text={GetESourceName(item.source)} />
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          <StatusContainer bg={ETypeBg(item.type)} text={GetETypeName(item.type)} />
                        </td>
                      </tr>
                    )}

                  </tbody>
                </table>
                : <Empty>
                  No Items Found.
                </Empty>
              : <LoadingContainer />
          }
        </div>
      </Paging>
    </div>
  )
}
